import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CampaignV2OffersQuery, CampaignV2OffersService } from '@fgb/core';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CampaignManagerOffersModel } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'fgb-campaigns-v2-offers-list',
  templateUrl: './campaigns-v2-offers-list.component.html',
  styleUrls: ['./campaigns-v2-offers-list.component.scss'],
})
export class CampaignsV2OffersListComponent implements OnInit {
  @Input() showAllOffersLink: string = '/rewards/wallet';
  @Input() showAllOffers: boolean = false;
  @Output() dataChange: EventEmitter<any> = new EventEmitter();
  activeOffers$: Observable<CampaignManagerOffersModel>;
  isDragging: boolean = false;
  customOptions: OwlOptions = {
    margin: 8,
    pullDrag: true,
    autoplay: false,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    nav: false,
    responsive: {
      0: { items: 2 },
      900: { items: 4 },
    },
    dots: true,
  };
  constructor(
    private campaignV2OffersService: CampaignV2OffersService,
    private campaignV2OffersQuery: CampaignV2OffersQuery
  ) {}

  ngOnInit() {
    firstValueFrom(this.campaignV2OffersService.fetchV2Offers());
    const now = new Date();
    this.activeOffers$ = this.campaignV2OffersQuery.selectFirst().pipe(
      tap((data) => this.dataChange.emit(data)),
      map((data) => ({
        Offers: data?.Offers?.filter((o) => new Date(o.DisplayUntilDate) >= now) ?? [],
        Vouchers: data?.Vouchers?.filter((v) => new Date(v.DisplayUntilDate) >= now) ?? [],
      }))
    );
  }
}
